import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";

const AddResources = ({ closeModal }) => {
  const navigate = useNavigate();
  const [searchInputChange, setSearchInputChange] = useState();
  const [selectMember, setSelectMember] = useState([]);
  const dispatch = useDispatch();
  const usersData = useSelector((state) => state.projects.searchUserResponseData);
  const projectCreateId = useSelector((state) => state.projects.createProjectResponse.project?._id);
  const projectCreatename = useSelector((state) => state.projects.createProjectResponse.project?.name);


  useEffect(() => {
    if (searchInputChange) {
      dispatch.projects.searchUserData(searchInputChange);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchInputChange]);

  const addMember = (member) => {
    const uniqueFilter = selectMember.findIndex(element => element._id === member._id)
    if (uniqueFilter < 0) {
      setSelectMember((prevMember) => [...prevMember, member]);
    } else {
      toast.error('The member has been already added!');
    }
    setSearchInputChange(null);
  }

  const removeMember = (member) => {
    const indexOfObject = selectMember.findIndex(object => {
      return object._id === member._id;
    });
    selectMember.splice(indexOfObject, 1);
    setSelectMember((prevMember) => [...prevMember]);
  }

  const handleSubmit = async () => {
    let payload = selectMember.map((user) => ({
      project_id: projectCreateId,
      user_id: user._id,
      status: "active"
    }))
    await dispatch.projects.inviteMember(payload)
      .then((response) => {
        const res = response.data;
        if (res.message && res.message.length > 0) {
          if (res.success) {
            toast.success(res.message);
            closeModal(true);
            navigate(`/projects/${projectCreatename}`);

          } else {
            toast.error(res.message);
          }
        }
      }).catch(({ response }) => {
        if (response.error && response.error.length > 0) {
          toast.error(response.error);
        }
      })
  }

  return (
    <div className="w-full">
      <div className="mb-12">
        <h3 className="font-title text-xl font-medium text-black mb-2">Create a New Project</h3>
        <span className="block text-sm text-secondary-grey-200">Step 2: Add users to project by name</span>
      </div>
      <div className="flex items-center mb-6 relative">
        <div className="absolute top-2/4 -translate-y-2/4 left-3 z-10">
          <svg width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.45028 0.686507C3.81051 0.769865 3.11031 1.03244 2.58932 1.38463C1.55569 2.08275 0.874241 3.16639 0.69919 4.38758C0.661679 4.65641 0.655427 5.25033 0.686686 5.51916C0.842982 6.77577 1.53068 7.89693 2.58932 8.61172C3.13115 8.97849 3.82718 9.23273 4.50863 9.31401C4.77746 9.34527 5.49225 9.32651 5.72982 9.28275C6.32582 9.17022 6.88432 8.9514 7.3532 8.64506L7.54909 8.51794L8.95783 9.9246C9.73306 10.6998 10.377 11.3333 10.3874 11.3333C10.4145 11.3333 11.3356 10.4122 11.3356 10.3852C11.3356 10.3747 10.7021 9.7308 9.92686 8.95557L8.52021 7.54683L8.64524 7.35094C8.96617 6.85913 9.1704 6.33606 9.28501 5.72755C9.32877 5.48998 9.34753 4.77519 9.31627 4.50636C9.16623 3.23308 8.47853 2.10567 7.41155 1.38463C6.87806 1.02411 6.1862 0.767781 5.52142 0.684423C5.31511 0.659416 4.65659 0.6615 4.45028 0.686507ZM5.28802 2.02856C5.93196 2.06816 6.66967 2.4266 7.14689 2.92674C7.69914 3.50607 7.98047 4.20419 7.98047 4.99817C7.98047 5.49207 7.89503 5.86092 7.68038 6.30063C7.35529 6.96749 6.83222 7.46139 6.1466 7.75522C5.3943 8.07615 4.48779 8.05739 3.75007 7.70521C3.48958 7.58017 3.37705 7.5114 3.15615 7.34052C2.57682 6.89247 2.17045 6.20477 2.05167 5.46706C2.01415 5.24616 2.00999 4.7877 2.04333 4.57513C2.22463 3.35812 3.12281 2.37866 4.31691 2.09108C4.52113 2.04107 4.92125 1.9973 5.04212 2.00981C5.07129 2.01398 5.18174 2.02231 5.28802 2.02856Z" fill="#54585D" />
          </svg>
        </div>
        {/* User custom search select */}
        <div className="relative w-full">
          <input className="appearance-none focus:outline-none focus:border-primary-navyBlue transition delay-150 duration-150 ease-linear text-base border rounded-md py-3 pl-9 pr-4 w-full placeholder-secondary-grey-300 text-secondary-grey-300 font-normal border-secondary-grey-400"
            type="text"
            value={searchInputChange || ''}
            onChange={event => setSearchInputChange(event.target.value)}
            placeholder='Choose members' />
          {/* search dropdown */}
          {searchInputChange?.length > 0 &&
            <div className="absolute z-10 top-14 w-full rounded shadow-200 border border-gray-200 bg-white">
              <ul className="pl-0">
                {usersData?.data?.result?.length > 0 ?
                  <>
                    {usersData?.data?.result?.length > 0 && usersData?.data?.result.map((user, index) => (
                      <li key={index} onClick={() => addMember(user)} className="text-sm p-3 border-b border-gray-200 last-of-type:border-0 bg-white hover:bg-primary-light">{user.first_name + " " + user.last_name}</li>
                    ))}
                  </>
                  : <li className="text-sm text-secondary-grey-300 py-2 px-3 bg-white text-center">No data</li>}
              </ul>
            </div>}
          {/* End search dropdown */}
        </div>
        {/* End User custom search select */}
      </div>

      {/* Selected Members */}
      <div className="mb-8">
        <h5 className="font-title text-sm font-medium text-secondary pb-4 border-b border-borderColor-200">Selected Members</h5>
        {selectMember?.length > 0 ?
          <div className="custom-scroll-wrapper max-h-72">
            {
              selectMember.map((member, index) => (
                <div key={index} className="flex items-center justify-between border-b border-borderColor-200 px-2 py-2">
                  <div className="flex items-center">
                    <div className="w-8 h-8 min-w-[32px] flex items-center justify-center mr-3 bg-secondary-blue-500 rounded-full">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.68649 9.90273V9.4416V8.46963V8.30907L9.75222 8.16258C9.84675 7.95192 9.92689 7.71831 9.9885 7.46067L10.0828 7.0664L10.4452 6.93614C10.4561 6.92603 10.4971 6.88571 10.5571 6.77367C10.6466 6.60666 10.7248 6.38047 10.7981 6.12172L10.7985 6.12043C10.8889 5.80309 10.9149 5.57967 10.909 5.43474C10.9055 5.34781 10.8917 5.30828 10.8866 5.29657L10.6584 5.03142L10.7232 4.67869C10.9677 3.34623 10.8075 2.59338 10.5264 2.22079C10.3903 2.04279 10.2423 1.97663 10.1544 1.9488L9.91658 1.87348L9.77124 1.67068C9.67694 1.5391 9.47085 1.29621 9.11238 1.09869L9.10221 1.09308L9.09221 1.08716C8.71857 0.865932 8.29257 0.75 7.80201 0.75C7.71731 0.75 7.62708 0.755036 7.53117 0.761429L7.52407 0.761903L7.51696 0.762242C7.31836 0.771699 7.11764 0.80908 6.9133 0.875252C6.90457 0.878401 6.89485 0.881725 6.88421 0.885081C6.66419 0.96263 6.44134 1.07624 6.2186 1.22823L6.20929 1.23458L6.19979 1.24065C5.93443 1.41026 5.69118 1.61267 5.4819 1.83555L5.47247 1.84559L5.47238 1.8455C5.06033 2.26847 4.80971 2.72216 4.70393 3.18219L4.70119 3.19409L4.69806 3.2059C4.59428 3.59827 4.58738 3.98725 4.67242 4.36993L4.77947 4.85169L4.37939 5.14063L4.37768 5.14194C4.37624 5.14505 4.37405 5.15034 4.37156 5.15847C4.3654 5.17866 4.357 5.21793 4.35544 5.28419C4.35216 5.42327 4.37966 5.63762 4.4692 5.95617L4.46941 5.95691C4.53433 6.18875 4.60102 6.38861 4.6756 6.54586C4.71209 6.62278 4.74554 6.67884 4.77405 6.71789C4.78792 6.73689 4.79922 6.74994 4.80742 6.75843C4.81534 6.76662 4.81954 6.76972 4.81957 6.76974L5.05863 6.94337L5.11502 7.23341C5.19287 7.63378 5.32185 7.98952 5.48951 8.29822L5.58044 8.46565V8.65617V9.44488V9.906L5.16896 10.1141C4.62479 10.3894 3.06636 11.2151 1.54379 12.3997L1.5437 12.3997C1.05069 12.7832 0.75 13.3951 0.75 14.0364V14.8873C0.75 15.0869 0.913491 15.25 1.1127 15.25H14.1542C14.3506 15.25 14.5169 15.0865 14.5169 14.884V14.0331C14.5169 13.3947 14.2159 12.7797 13.7233 12.3966L9.68649 9.90273ZM9.68649 9.90273L10.098 10.1109M9.68649 9.90273L10.098 10.1109M10.098 10.1109C10.6411 10.3856 12.2 11.2147 13.7232 12.3965L10.098 10.1109ZM4.37428 5.14466L4.37436 5.14458C4.3743 5.14464 4.37427 5.14466 4.37428 5.14466ZM6.99628 0.839667C6.9956 0.840008 6.99451 0.840548 6.99333 0.841132L6.99557 0.840024L6.99628 0.839667Z" stroke="white" strokeWidth="1.5" />
                      </svg>
                      {/* <img src="" alt="profile" /> */}
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm text-secondary font-title font-semibold">{member.email}</span>
                      <span className="text-xs text-greyColor-200 font-title">{member.designation?.name}</span>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div>
                      <button className="text-xs opacity-75 hover:opacity-95" type="button" onClick={() => removeMember(member)}>
                       
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0833 14H2.91666C2.27266 14 1.74999 13.4773 1.74999 12.8333V2.91667H1.16666V1.75H4.66666V0.875C4.66666 0.392583 5.05924 0 5.54166 0H8.45832C8.93957 0 9.33332 0.391417 9.33332 0.875V1.75H12.8333V2.91667H12.25V12.8333C12.25 13.4773 11.7273 14 11.0833 14ZM11.0833 2.91667H2.91666V12.5417C2.91666 12.7027 3.04732 12.8333 3.20832 12.8333H10.7917C10.9527 12.8333 11.0833 12.7027 11.0833 12.5417V2.91667ZM5.83332 5.25C5.83332 4.928 5.57199 4.66667 5.24999 4.66667C4.92799 4.66667 4.66666 4.928 4.66666 5.25V10.5C4.66666 10.822 4.92799 11.0833 5.24999 11.0833C5.57199 11.0833 5.83332 10.822 5.83332 10.5V5.25ZM9.33332 5.25C9.33332 4.928 9.07199 4.66667 8.74999 4.66667C8.42799 4.66667 8.16666 4.928 8.16666 5.25V10.5C8.16666 10.822 8.42799 11.0833 8.74999 11.0833C9.07199 11.0833 9.33332 10.822 9.33332 10.5V5.25ZM8.16666 1.16667H5.83332V1.75H8.16666V1.16667Z" fill="#F74051"/>
                        </svg>

                      </button>
                    </div>

                    {/* <div className="relative">
                      <div className="absolute top-2/4 -translate-y-2/4 right-2 z-0">
                        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5 7L5.82818e-07 0.333333L10 0.333334L5 7Z" fill="#656A6F" />
                        </svg>
                      </div>
                      <select className="relative z-1 cursor-pointer appearance-none bg-transparent text-xs focus:outline-none py-2 pl-3 pr-7 text-right">
                        {member.roles?.length > 0 && member.roles.map((role) => (
                          <option key={role._id}>{role.name}</option>
                        ))}
                      </select>
                    </div> */}


                  </div>
                </div>
              ))
            }
          </div>
          : <span className="flex items-center justify-center py-4 text-sm text-greyColor-200 font-title">No members added yet</span>
        }
      </div>
      {/* End Selected Members */}

      <button type="button" onClick={() => handleSubmit()} className="w-full p-4 bg-primary-navyBlue hover:bg-opacity-75 transition delay-150 duration-150 ease-linear text-white rounded-md text-sm font-semibold font-title">Finish</button>

    </div>
  )
}

export default AddResources